import { FC, useMemo } from 'react'
import {
  DataGridPremium,
  useGridApiRef,
} from '@mui/x-data-grid-premium'
import { SensorBatteryStats as SensorBatteryStatsType } from 'src/api'
import { SensorBatteryStatsColumns } from 'src/components/columns/sensorBatteryStats'
import { useSensorBatteryStats } from 'src/hooks/api'

interface Props {
  sensorUniqueId: string
}

const getColumns = () => [
  SensorBatteryStatsColumns.BatteryStartValue,
  SensorBatteryStatsColumns.DaysSinceLastCharge,
  SensorBatteryStatsColumns.CurrentBattery,
  SensorBatteryStatsColumns.DailyDischargeRate,
  SensorBatteryStatsColumns.EstimatedDaysRemaining,
]

export const SensorBatteryStats: FC<Props> = ({ sensorUniqueId }) => {
  const apiRef = useGridApiRef()
  const { data, isInitialLoading } = useSensorBatteryStats({
    params: { uniqueId: sensorUniqueId },
  })

  const rows = useMemo(() => (data ? [data] : []), [data])

  return (
    <DataGridPremium<SensorBatteryStatsType>
      apiRef={apiRef}
      autoHeight
      disableRowSelectionOnClick
      rows={rows}
      columns={getColumns()}
      loading={isInitialLoading}
      getRowId={() => 'battery-stats'}
      hideFooter
      rowThreshold={2}
      columnThreshold={2}
      localeText={{
        columnMenuSortAsc: 'Sort A-Z',
        columnMenuSortDesc: 'Sort Z-A',
      }}
      sx={(theme) => ({
        border: 'none',
        '& .MuiDataGrid-columnHeaderTitleContainerContent': {
          paddingLeft: '5px',
          overflow: 'visible',
        },
        '& .MuiDataGrid-columnHeaderTitle': {
          whiteSpace: 'normal',
          lineHeight: 1,
          fontSize: '13px',
          fontWeight: 400,
          color: 'rgba(0, 0, 0, 0.6)',
          overflow: 'visible',
        },
      })}
    />
  )
}
